export default __webpack_public_path__ + "chevron.62234094e911d584.svg";